/* eslint-disable indent */
import config from '../config';
import i18n from '../i18';

export const adaptedName = (name) => {
    return name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
};

const jsonRegex = /^[{[].*[}\]]$/;

export const isValidJSON = (str) => {
    if (typeof str !== 'string' || !jsonRegex.test(str.trim())) return false;
    try {
        JSON.parse(str);
        return true;
    } catch {
        return false;
    }
};

const getParsedName = (item, language) => {
    const parsedValue = JSON.parse(item.name);
    return parsedValue[language];
};

const getEnumName = (name) => {
    // eslint-disable-next-line indent
    const translationKey = 'enums.' + name;
    const translated = i18n.t(translationKey);
    // If the translation is missing, i18next returns the key itself => fallback to raw name
    return translated === translationKey ? name : translated;
};

const getRangeName = (item, field) => {
    const fromName = item?.[field.fromObj]?.name || '';
    const toName = item?.[field.toObj]?.name || '';
    return `${fromName} - ${toName}`;
};

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export function getNestedValue(obj, path) {
    if (!obj || !path) return undefined;
    return path
        .split('.')
        .reduce(
            (acc, key) =>
                acc && acc[key] !== undefined ? acc[key] : undefined,
            obj
        );
}

function handleNestedDisplay(display, nested, data, fallbackNested) {
    let value = getNestedValue(data, nested);
    if (!value && fallbackNested) {
        value = getNestedValue(data, fallbackNested);
    }
    return value ? getDisplayName(value, display) : '';
}

function handleStringDisplay(value, display) {
    const val = value
        ? display
              .split('+')
              .map((key) => getNestedValue(value, key))
              .filter(Boolean)
              .join(' ')
        : '';
    if (isValidJSON(val)) {
        return getParsedName({ name: val }, config.language);
    }
    return val;
}

function handleFunctionDisplay(value, display) {
    return display(value);
}

export function getDisplayName(value, display, fallbackDisplay) {
    let name = value;
    if (typeof display === 'function') {
        name = handleFunctionDisplay(value, display);
    } else if (typeof display === 'string') {
        name = handleStringDisplay(value, display);
    }
    if (!name && fallbackDisplay) {
        name = handleStringDisplay(value, fallbackDisplay);
    }
    return name || '';
}

export function getDisplayValue(value, field, data = {}) {
    const { display, fallbackDisplay, nested, fallbackNested } = field;

    if (nested) {
        return handleNestedDisplay(display, nested, data, fallbackNested);
    }

    if (display === 'range') {
        return getRangeName(value, field);
    }

    return getDisplayName(value, display, fallbackDisplay);
}

export const formatName = (item, display, field) => {
    if (item.name) {
        if (isValidJSON(item.name)) {
            return getParsedName(item, config.language);
        }
        if (field.enumType) {
            return getEnumName(item.name);
        }
        return item.name;
    }

    if (display) {
        return display === 'range'
            ? getRangeName(item, field)
            : getDisplayName(item, display);
    }

    return item?.id ? 'ID: ' + item.id : '';
};
export const getFilterField = (field) => {
    return field.filterField ?? transformFieldToFilter(field.id, field.object);
};
export const transformFieldToFilter = (field, object = null) => {
    return object ? `${object}.id` : field;
};

export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

export const tNameFieldToCamelCase = (field) => {
    //ex: 'user.name' => 'userName'
    return field
        .split('.')
        .map((str, index) => {
            return index === 0 ? str : capitalize(str);
        })
        .join('');
};
